module.exports = __webpack_public_path__ + "img/dprCoin.c633fc87.png";